import { EditProjectContextProps } from "../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { getIdOfSpdrOrPdsr } from "./GetIdOfSpdrOrPdsr";

export function getLtlPipeline(
  editProjectContext: EditProjectContextProps
): LtlPipelineViewModel {
  const { project, selectedLtlSpdrOrPdsr } = editProjectContext;
  if (!selectedLtlSpdrOrPdsr) {
    throw new Error("selectedLtlSpdr undefined");
  }

  const spdrOrPdsrId = getIdOfSpdrOrPdsr(selectedLtlSpdrOrPdsr);

  const ltlPipeline = project?.ltlPipelines?.find(
    (p) => p.SpdrId === spdrOrPdsrId || p.PdsrId === spdrOrPdsrId
  );
  if (!ltlPipeline) {
    throw new Error("ltlPipeline undefined");
  }
  return ltlPipeline;
}
